import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('users');
  const [selectedUser, setSelectedUser] = useState(null);
  const [showUserModal, setShowUserModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [showKycModal, setShowKycModal] = useState(false);
  const [selectedKycRequest, setSelectedKycRequest] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessageText, setSuccessMessageText] = useState('');
  const [showDocumentViewer, setShowDocumentViewer] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState('');

  const stats = [
    { label: 'Total Users', value: '24,567', change: '+12.5%', icon: 'ri-user-line', color: 'emerald' },
    { label: 'Total Volume', value: '$98.5M', change: '+8.3%', icon: 'ri-line-chart-line', color: 'green' },
    { label: 'Active Trades', value: '1,234', change: '+5.7%', icon: 'ri-exchange-line', color: 'orange' },
    { label: 'Pending KYC', value: '156', change: '-3.2%', icon: 'ri-user-star-line', color: 'purple' },
  ];

  const recentUsers = [
    { id: '1', name: 'John Smith', email: 'john@example.com', status: 'Active', joined: '2024-01-15', kyc: 'Verified' },
    { id: '2', name: 'Sarah Johnson', email: 'sarah@example.com', status: 'Active', joined: '2024-01-14', kyc: 'Pending' },
    { id: '3', name: 'Michael Brown', email: 'michael@example.com', status: 'Active', joined: '2024-01-13', kyc: 'Verified' },
    { id: '4', name: 'Emily Davis', email: 'emily@example.com', status: 'Inactive', joined: '2024-01-12', kyc: 'Not Started' },
  ];

  const recentTransactions = [
    { id: '1', user: 'John Smith', type: 'Buy', asset: 'BTC', amount: '0.5', value: '$21,625', status: 'Completed', date: '2024-03-20 14:30', txHash: '0x1a2b3c4d5e6f7g8h9i0j', fee: '$10.81', wallet: '0x742d...4e8a' },
    { id: '2', user: 'Sarah Johnson', type: 'Sell', asset: 'USDT', amount: '1000', value: '$1,000', status: 'Completed', date: '2024-03-20 13:15', txHash: '0x9i8h7g6f5e4d3c2b1a0j', fee: '$5.00', wallet: '0x8b3f...2c9d' },
    { id: '3', user: 'Michael Brown', type: 'Trade', asset: 'ETH', amount: '2.5', value: '$5,702', status: 'Pending', date: '2024-03-20 12:45', txHash: '0x5f6g7h8i9j0k1l2m3n4o', fee: '$28.51', wallet: '0x4d2a...7f1b' },
    { id: '4', user: 'Emily Davis', type: 'Withdraw', asset: 'BTC', amount: '0.1', value: '$4,325', status: 'Processing', date: '2024-03-20 11:20', txHash: '0x3n4o5p6q7r8s9t0u1v2w', fee: '$21.63', wallet: '0x9e5c...3a8f' },
  ];

  const kycRequests = [
    { id: '1', user: 'Sarah Johnson', email: 'sarah.j@email.com', submitted: '2024-01-15 10:30', status: 'Pending Review', documents: 3, documentList: ['Passport', 'Proof of Address', 'Selfie with ID'], country: 'United Kingdom', phone: '+44 20 7946 0958' },
    { id: '2', user: 'David Wilson', email: 'david.w@email.com', submitted: '2024-01-14 15:45', status: 'Under Review', documents: 3, documentList: ['Driver License', 'Bank Statement', 'Selfie with ID'], country: 'Canada', phone: '+1 416 555 0123' },
    { id: '3', user: 'Lisa Anderson', email: 'lisa.a@email.com', submitted: '2024-01-13 09:20', status: 'Pending Review', documents: 2, documentList: ['National ID', 'Utility Bill'], country: 'Germany', phone: '+49 30 1234567' },
    { id: '4', user: 'James Taylor', email: 'james.t@email.com', submitted: '2024-01-12 14:10', status: 'Pending Review', documents: 3, documentList: ['Passport', 'Proof of Address', 'Selfie with ID'], country: 'Australia', phone: '+61 2 9374 4000' },
  ];

  const users = [
    { id: 1, name: 'John Smith', email: 'john.smith@email.com', status: 'Active', kycStatus: 'Verified', balance: '$12,450.00', joinDate: '2024-01-15', phone: '+1 234 567 8900', country: 'United States', lastLogin: '2024-03-20 14:30', totalTransactions: 45, verifiedDocuments: 'Passport, Proof of Address' },
    { id: 2, name: 'Sarah Johnson', email: 'sarah.j@email.com', status: 'Active', kycStatus: 'Pending', balance: '$8,320.50', joinDate: '2024-02-03', phone: '+44 20 7946 0958', country: 'United Kingdom', lastLogin: '2024-03-19 09:15', totalTransactions: 23, verifiedDocuments: 'Driver License' },
    { id: 3, name: 'Michael Chen', email: 'mchen@email.com', status: 'Active', kycStatus: 'Verified', balance: '$25,890.75', joinDate: '2024-01-08', phone: '+86 138 0013 8000', country: 'China', lastLogin: '2024-03-20 16:45', totalTransactions: 78, verifiedDocuments: 'National ID, Bank Statement' },
    { id: 4, name: 'Emma Wilson', email: 'emma.w@email.com', status: 'Suspended', kycStatus: 'Rejected', balance: '$0.00', joinDate: '2024-03-01', phone: '+61 2 9374 4000', country: 'Australia', lastLogin: '2024-03-15 11:20', totalTransactions: 5, verifiedDocuments: 'None' },
    { id: 5, name: 'David Martinez', email: 'david.m@email.com', status: 'Active', kycStatus: 'Verified', balance: '$15,670.25', joinDate: '2024-01-20', phone: '+34 91 123 4567', country: 'Spain', lastLogin: '2024-03-20 13:00', totalTransactions: 56, verifiedDocuments: 'Passport, Utility Bill' },
  ];

  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setShowUserModal(true);
  };

  const handleCloseModal = () => {
    setShowUserModal(false);
    setSelectedUser(null);
  };

  const handleViewTransactionDetails = (transaction) => {
    setSelectedTransaction(transaction);
    setShowTransactionModal(true);
  };

  const handleCloseTransactionModal = () => {
    setShowTransactionModal(false);
    setSelectedTransaction(null);
  };

  const handleViewKycDetails = (request) => {
    setSelectedKycRequest(request);
    setShowKycModal(true);
  };

  const handleCloseKycModal = () => {
    setShowKycModal(false);
    setSelectedKycRequest(null);
  };

  const handleApproveKyc = (request) => {
    setSuccessMessageText(`KYC verification for ${request.user} has been approved successfully!`);
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
      if (showKycModal) {
        handleCloseKycModal();
      }
    }, 3000);
  };

  const handleRejectKyc = (request) => {
    setSuccessMessageText(`KYC verification for ${request.user} has been rejected.`);
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
      if (showKycModal) {
        handleCloseKycModal();
      }
    }, 3000);
  };

  const handleViewDocument = (documentName) => {
    setSelectedDocument(documentName);
    setShowDocumentViewer(true);
  };

  const handleCloseDocumentViewer = () => {
    setShowDocumentViewer(false);
    setSelectedDocument('');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Success Message */}
      {showSuccessMessage && (
        <div className="fixed top-24 left-1/2 transform -translate-x-1/2 z-50 animate-fade-in">
          <div className="bg-white rounded-xl shadow-2xl px-6 py-4 flex items-center gap-4 border-l-4 border-emerald-600">
            <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
              <i className="ri-check-line text-xl text-emerald-600"></i>
            </div>
            <p className="font-semibold text-gray-900">{successMessageText}</p>
          </div>
        </div>
      )}

      <div className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-2">Admin Dashboard</h1>
            <p className="text-lg text-gray-600">Manage users, transactions, and platform operations</p>
          </div>

          {/* Stats Grid */}
          <div className="grid md:grid-cols-4 gap-6 mb-8">
            {stats.map((stat, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 bg-${stat.color}-100 rounded-lg flex items-center justify-center`}>
                    <i className={`${stat.icon} text-2xl text-${stat.color}-600`}></i>
                  </div>
                  <span className={`text-sm font-semibold ${stat.change.startsWith('+') ? 'text-green-600' : 'text-red-600'}`}>
                    {stat.change}
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-1">{stat.label}</p>
                <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
              </div>
            ))}
          </div>

          {/* Tabs */}
          <div className="bg-white rounded-xl p-2 inline-flex gap-2 mb-8 shadow-sm">
            <button
              onClick={() => setActiveTab('overview')}
              className={`px-6 py-3 rounded-lg font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === 'overview' ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Overview
            </button>
            <button
              onClick={() => setActiveTab('users')}
              className={`px-6 py-3 rounded-lg font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === 'users' ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Users
            </button>
            <button
              onClick={() => setActiveTab('transactions')}
              className={`px-6 py-3 rounded-lg font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === 'transactions' ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Transactions
            </button>
            <button
              onClick={() => setActiveTab('kyc')}
              className={`px-6 py-3 rounded-lg font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === 'kyc' ? 'bg-emerald-600 text-white' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              KYC Requests
            </button>
          </div>

          {/* Overview Tab */}
          {activeTab === 'overview' && (
            <div className="space-y-8">
              <div className="bg-white rounded-xl shadow-sm p-6">
                <h2 className="text-xl font-bold text-gray-900 mb-6">Recent Activity</h2>
                <div className="space-y-4">
                  <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
                    <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                      <i className="ri-user-add-line text-xl text-emerald-600"></i>
                    </div>
                    <div className="flex-1">
                      <p className="font-semibold text-gray-900">New user registered</p>
                      <p className="text-sm text-gray-600">John Smith joined the platform</p>
                    </div>
                    <p className="text-sm text-gray-500">2 min ago</p>
                  </div>
                  <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
                    <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-xl text-green-600"></i>
                    </div>
                    <div className="flex-1">
                      <p className="font-semibold text-gray-900">KYC approved</p>
                      <p className="text-sm text-gray-600">Sarah Johnson's verification completed</p>
                    </div>
                    <p className="text-sm text-gray-500">15 min ago</p>
                  </div>
                  <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
                    <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
                      <i className="ri-exchange-line text-xl text-orange-600"></i>
                    </div>
                    <div className="flex-1">
                      <p className="font-semibold text-gray-900">Large transaction</p>
                      <p className="text-sm text-gray-600">Michael Brown traded $50,000 worth of BTC</p>
                    </div>
                    <p className="text-sm text-gray-500">1 hour ago</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Users Tab */}
          {activeTab === 'users' && (
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-sm font-bold text-gray-900">User</th>
                      <th className="px-6 py-4 text-left text-sm font-bold text-gray-900">Email</th>
                      <th className="px-6 py-4 text-left text-sm font-bold text-gray-900">Status</th>
                      <th className="px-6 py-4 text-left text-sm font-bold text-gray-900">KYC</th>
                      <th className="px-6 py-4 text-left text-sm font-bold text-gray-900">Balance</th>
                      <th className="px-6 py-4 text-left text-sm font-bold text-gray-900">Join Date</th>
                      <th className="px-6 py-4 text-left text-sm font-bold text-gray-900">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {users.map((user) => (
                      <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                              <span className="text-emerald-600 font-bold text-sm">{user.name.charAt(0)}</span>
                            </div>
                            <span className="font-semibold text-gray-900 text-sm">{user.name}</span>
                          </div>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-600">{user.email}</td>
                        <td className="px-6 py-4">
                          <span className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
                            user.status === 'Active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                          }`}>
                            {user.status}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
                            user.kycStatus === 'Verified' ? 'bg-green-100 text-green-700' : 
                            user.kycStatus === 'Pending' ? 'bg-yellow-100 text-yellow-700' : 
                            'bg-red-100 text-red-700'
                          }`}>
                            {user.kycStatus}
                          </span>
                        </td>
                        <td className="px-6 py-4 font-semibold text-gray-900 text-sm">{user.balance}</td>
                        <td className="px-6 py-4 text-sm text-gray-600">{user.joinDate}</td>
                        <td className="px-6 py-4">
                          <button 
                            onClick={() => handleViewDetails(user)}
                            className="text-emerald-600 hover:text-emerald-700 font-medium text-sm cursor-pointer whitespace-nowrap"
                          >
                            View Details
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Transactions Tab */}
          {activeTab === 'transactions' && (
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-between">
                  <h2 className="text-xl font-bold text-gray-900">Transaction Management</h2>
                  <button className="px-4 py-2 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer">
                    Export Transactions
                  </button>
                </div>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">User</th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Type</th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Asset</th>
                      <th className="px-6 py-4 text-right text-sm font-semibold text-gray-900">Amount</th>
                      <th className="px-6 py-4 text-right text-sm font-semibold text-gray-900">Value</th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Status</th>
                      <th className="px-6 py-4 text-right text-sm font-semibold text-gray-900">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {recentTransactions.map((tx) => (
                      <tr key={tx.id} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 font-semibold text-gray-900">{tx.user}</td>
                        <td className="px-6 py-4">
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-emerald-100 text-emerald-800">
                            {tx.type}
                          </span>
                        </td>
                        <td className="px-6 py-4 font-semibold text-gray-900">{tx.asset}</td>
                        <td className="px-6 py-4 text-right text-gray-900">{tx.amount}</td>
                        <td className="px-6 py-4 text-right font-semibold text-gray-900">{tx.value}</td>
                        <td className="px-6 py-4">
                          <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                            tx.status === 'Completed' ? 'bg-green-100 text-green-800' : 
                            tx.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' : 
                            'bg-orange-100 text-orange-800'
                          }`}>
                            {tx.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-right">
                          <button 
                            onClick={() => handleViewTransactionDetails(tx)}
                            className="text-emerald-600 hover:text-emerald-700 font-medium text-sm cursor-pointer whitespace-nowrap"
                          >
                            View Details
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* KYC Tab */}
          {activeTab === 'kyc' && (
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              <div className="p-6 border-b border-gray-200">
                <h2 className="text-xl font-bold text-gray-900">KYC Verification Requests</h2>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">User</th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Submitted</th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Documents</th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Status</th>
                      <th className="px-6 py-4 text-right text-sm font-semibold text-gray-900">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {kycRequests.map((request) => (
                      <tr key={request.id} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4">
                          <div>
                            <p className="font-semibold text-gray-900">{request.user}</p>
                            <p className="text-sm text-gray-600">{request.email}</p>
                          </div>
                        </td>
                        <td className="px-6 py-4 text-gray-600">{request.submitted}</td>
                        <td className="px-6 py-4 text-gray-900">{request.documents} files</td>
                        <td className="px-6 py-4">
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
                            {request.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-right">
                          <div className="flex items-center justify-end gap-2">
                            <button 
                              onClick={() => handleApproveKyc(request)}
                              className="px-3 py-1 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
                            >
                              Approve
                            </button>
                            <button 
                              onClick={() => handleRejectKyc(request)}
                              className="px-3 py-1 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
                            >
                              Reject
                            </button>
                            <button 
                              onClick={() => handleViewKycDetails(request)}
                              className="px-3 py-1 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
                            >
                              View Details
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* User Details Modal */}
      {showUserModal && selectedUser && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-6" onClick={handleCloseModal}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-900">User Details</h2>
              <button 
                onClick={handleCloseModal}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-8 space-y-6">
              {/* User Profile */}
              <div className="flex items-center gap-6 pb-6 border-b border-gray-200">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center">
                  <span className="text-emerald-600 font-bold text-3xl">{selectedUser.name.charAt(0)}</span>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-1">{selectedUser.name}</h3>
                  <p className="text-gray-600">{selectedUser.email}</p>
                  <div className="flex items-center gap-3 mt-2">
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
                      selectedUser.status === 'Active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                    }`}>
                      {selectedUser.status}
                    </span>
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
                      selectedUser.kycStatus === 'Verified' ? 'bg-green-100 text-green-700' : 
                      selectedUser.kycStatus === 'Pending' ? 'bg-yellow-100 text-yellow-700' : 
                      'bg-red-100 text-red-700'
                    }`}>
                      KYC: {selectedUser.kycStatus}
                    </span>
                  </div>
                </div>
              </div>

              {/* Account Information */}
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-4">Account Information</h4>
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">User ID</p>
                    <p className="font-semibold text-gray-900">#{selectedUser.id.toString().padStart(6, '0')}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Join Date</p>
                    <p className="font-semibold text-gray-900">{selectedUser.joinDate}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Phone Number</p>
                    <p className="font-semibold text-gray-900">{selectedUser.phone}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Country</p>
                    <p className="font-semibold text-gray-900">{selectedUser.country}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Last Login</p>
                    <p className="font-semibold text-gray-900">{selectedUser.lastLogin}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Total Transactions</p>
                    <p className="font-semibold text-gray-900">{selectedUser.totalTransactions}</p>
                  </div>
                </div>
              </div>

              {/* Wallet Balance */}
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-4">Wallet Balance</h4>
                <div className="bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl p-6 text-white">
                  <p className="text-sm opacity-90 mb-2">Total Balance</p>
                  <p className="text-4xl font-bold">{selectedUser.balance}</p>
                </div>
              </div>

              {/* KYC Information */}
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-4">KYC Verification</h4>
                <div className="bg-gray-50 rounded-xl p-6">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Verification Status</p>
                      <p className="font-semibold text-gray-900">{selectedUser.kycStatus}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Verified Documents</p>
                      <p className="font-semibold text-gray-900">{selectedUser.verifiedDocuments}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4 pt-6 border-t border-gray-200">
                <button className="flex-1 px-6 py-3 bg-emerald-600 text-white rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer">
                  Send Message
                </button>
                <button className="flex-1 px-6 py-3 bg-gray-100 text-gray-900 rounded-lg font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer">
                  View Transactions
                </button>
                {selectedUser.status === 'Active' ? (
                  <button className="px-6 py-3 bg-red-100 text-red-700 rounded-lg font-semibold hover:bg-red-200 transition-colors whitespace-nowrap cursor-pointer">
                    Suspend Account
                  </button>
                ) : (
                  <button className="px-6 py-3 bg-green-100 text-green-700 rounded-lg font-semibold hover:bg-green-200 transition-colors whitespace-nowrap cursor-pointer">
                    Activate Account
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Transaction Details Modal */}
      {showTransactionModal && selectedTransaction && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-6" onClick={handleCloseTransactionModal}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-900">Transaction Details</h2>
              <button 
                onClick={handleCloseTransactionModal}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-8 space-y-6">
              {/* Transaction Status */}
              <div className="text-center pb-6 border-b border-gray-200">
                <div className={`w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center ${
                  selectedTransaction.status === 'Completed' ? 'bg-green-100' : 
                  selectedTransaction.status === 'Pending' ? 'bg-yellow-100' : 
                  'bg-orange-100'
                }`}>
                  <i className={`text-4xl ${
                    selectedTransaction.status === 'Completed' ? 'ri-check-line text-green-600' : 
                    selectedTransaction.status === 'Pending' ? 'ri-time-line text-yellow-600' : 
                    'ri-loader-4-line text-orange-600'
                  }`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{selectedTransaction.value}</h3>
                <span className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold ${
                  selectedTransaction.status === 'Completed' ? 'bg-green-100 text-green-700' : 
                  selectedTransaction.status === 'Pending' ? 'bg-yellow-100 text-yellow-700' : 
                  'bg-orange-100 text-orange-700'
                }`}>
                  {selectedTransaction.status}
                </span>
              </div>

              {/* Transaction Information */}
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-4">Transaction Information</h4>
                <div className="space-y-4">
                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-gray-600">Transaction ID</span>
                    <span className="font-semibold text-gray-900">#{selectedTransaction.id.padStart(8, '0')}</span>
                  </div>
                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-gray-600">Type</span>
                    <span className="font-semibold text-gray-900">{selectedTransaction.type}</span>
                  </div>
                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-gray-600">Asset</span>
                    <span className="font-semibold text-gray-900">{selectedTransaction.asset}</span>
                  </div>
                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-gray-600">Amount</span>
                    <span className="font-semibold text-gray-900">{selectedTransaction.amount} {selectedTransaction.asset}</span>
                  </div>
                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-gray-600">Transaction Fee</span>
                    <span className="font-semibold text-gray-900">{selectedTransaction.fee}</span>
                  </div>
                  <div className="flex items-center justify-between py-3 border-b border-gray-100">
                    <span className="text-gray-600">Date & Time</span>
                    <span className="font-semibold text-gray-900">{selectedTransaction.date}</span>
                  </div>
                </div>
              </div>

              {/* User Information */}
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-4">User Information</h4>
                <div className="bg-gray-50 rounded-xl p-6">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                      <span className="text-emerald-600 font-bold text-lg">{selectedTransaction.user.charAt(0)}</span>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900">{selectedTransaction.user}</p>
                      <p className="text-sm text-gray-600">Wallet: {selectedTransaction.wallet}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Blockchain Information */}
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-4">Blockchain Information</h4>
                <div className="bg-gray-50 rounded-xl p-6">
                  <div className="space-y-3">
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Transaction Hash</p>
                      <div className="flex items-center gap-2">
                        <p className="font-mono text-sm text-gray-900 break-all">{selectedTransaction.txHash}</p>
                        <button className="p-2 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer">
                          <i className="ri-file-copy-line text-gray-600"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4 pt-6 border-t border-gray-200">
                {selectedTransaction.status === 'Pending' && (
                  <>
                    <button className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
                      Approve Transaction
                    </button>
                    <button className="flex-1 px-6 py-3 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer">
                      Reject Transaction
                    </button>
                  </>
                )}
                {selectedTransaction.status === 'Processing' && (
                  <button className="flex-1 px-6 py-3 bg-emerald-600 text-white rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer">
                    Mark as Completed
                  </button>
                )}
                {selectedTransaction.status === 'Completed' && (
                  <button className="flex-1 px-6 py-3 bg-emerald-600 text-white rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer">
                    Download Receipt
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* KYC Details Modal */}
      {showKycModal && selectedKycRequest && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-6" onClick={handleCloseKycModal}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-900">KYC Verification Details</h2>
              <button 
                onClick={handleCloseKycModal}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="p-8 space-y-6">
              {/* User Profile */}
              <div className="flex items-center gap-6 pb-6 border-b border-gray-200">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center">
                  <span className="text-emerald-600 font-bold text-3xl">{selectedKycRequest.user.charAt(0)}</span>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-1">{selectedKycRequest.user}</h3>
                  <p className="text-gray-600">{selectedKycRequest.email}</p>
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-700 mt-2">
                    {selectedKycRequest.status}
                  </span>
                </div>
              </div>

              {/* Submission Information */}
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-4">Submission Information</h4>
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Request ID</p>
                    <p className="font-semibold text-gray-900">#{selectedKycRequest.id.padStart(8, '0')}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Submitted Date</p>
                    <p className="font-semibold text-gray-900">{selectedKycRequest.submitted}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Phone Number</p>
                    <p className="font-semibold text-gray-900">{selectedKycRequest.phone}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Country</p>
                    <p className="font-semibold text-gray-900">{selectedKycRequest.country}</p>
                  </div>
                </div>
              </div>

              {/* Submitted Documents */}
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-4">Submitted Documents ({selectedKycRequest.documents})</h4>
                <div className="space-y-3">
                  {selectedKycRequest.documentList.map((doc, index) => (
                    <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
                          <i className="ri-file-text-line text-2xl text-emerald-600"></i>
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">{doc}</p>
                          <p className="text-sm text-gray-600">Uploaded on {selectedKycRequest.submitted.split(' ')[0]}</p>
                        </div>
                      </div>
                      <button 
                        onClick={() => handleViewDocument(doc)}
                        className="px-4 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-eye-line mr-2"></i>
                        View Document
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              {/* Verification Notes */}
              <div>
                <h4 className="text-lg font-bold text-gray-900 mb-4">Verification Notes</h4>
                <textarea 
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-none"
                  rows={4}
                  placeholder="Add notes about this verification request..."
                ></textarea>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4 pt-6 border-t border-gray-200">
                <button 
                  onClick={() => handleApproveKyc(selectedKycRequest)}
                  className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-check-line text-xl"></i>
                  Approve Verification
                </button>
                <button 
                  onClick={() => handleRejectKyc(selectedKycRequest)}
                  className="flex-1 px-6 py-3 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-close-line text-xl"></i>
                  Reject Verification
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Document Viewer Modal */}
      {showDocumentViewer && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-[60] p-6" onClick={handleCloseDocumentViewer}>
          <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden" onClick={(e) => e.stopPropagation()}>
            <div className="bg-gray-900 px-8 py-6 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                  <i className="ri-file-text-line text-xl text-white"></i>
                </div>
                <div>
                  <h2 className="text-xl font-bold text-white">{selectedDocument}</h2>
                  <p className="text-sm text-gray-400">KYC Verification Document</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <button className="px-4 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2">
                  <i className="ri-download-line"></i>
                  Download
                </button>
                <button 
                  onClick={handleCloseDocumentViewer}
                  className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-800 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl text-white"></i>
                </button>
              </div>
            </div>

            <div className="p-8 bg-gray-50 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 100px)' }}>
              <div className="bg-white rounded-xl shadow-lg p-8 mb-6">
                <div className="flex items-center justify-between mb-6 pb-6 border-b border-gray-200">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{selectedDocument}</h3>
                    <p className="text-gray-600">Document Preview</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-600 mb-1">Document ID</p>
                    <p className="font-mono font-semibold text-gray-900">DOC-{Math.random().toString(36).substr(2, 9).toUpperCase()}</p>
                  </div>
                </div>

                <div className="space-y-6">
                  {/* Document Image Preview */}
                  <div className="bg-gray-100 rounded-xl p-8 flex items-center justify-center" style={{ minHeight: '400px' }}>
                    <div className="text-center">
                      <div className="w-32 h-32 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                        <i className="ri-file-text-line text-6xl text-emerald-600"></i>
                      </div>
                      <p className="text-xl font-semibold text-gray-900 mb-2">{selectedDocument}</p>
                      <p className="text-gray-600 mb-6">Document preview would appear here</p>
                      <div className="flex items-center justify-center gap-4">
                        <div className="px-4 py-2 bg-white rounded-lg shadow-sm">
                          <p className="text-sm text-gray-600">File Type</p>
                          <p className="font-semibold text-gray-900">PDF / Image</p>
                        </div>
                        <div className="px-4 py-2 bg-white rounded-lg shadow-sm">
                          <p className="text-sm text-gray-600">File Size</p>
                          <p className="font-semibold text-gray-900">2.4 MB</p>
                        </div>
                        <div className="px-4 py-2 bg-white rounded-lg shadow-sm">
                          <p className="text-sm text-gray-600">Upload Date</p>
                          <p className="font-semibold text-gray-900">{selectedKycRequest?.submitted.split(' ')[0]}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Document Information */}
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="bg-gray-50 rounded-xl p-6">
                      <h4 className="font-bold text-gray-900 mb-4">Document Details</h4>
                      <div className="space-y-3">
                        <div>
                          <p className="text-sm text-gray-600 mb-1">Document Type</p>
                          <p className="font-semibold text-gray-900">{selectedDocument}</p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-600 mb-1">Submitted By</p>
                          <p className="font-semibold text-gray-900">{selectedKycRequest?.user}</p>
                        </div>
                        <div>
                          <p className="text-sm text-gray-600 mb-1">Submission Date</p>
                          <p className="font-semibold text-gray-900">{selectedKycRequest?.submitted}</p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-xl p-6">
                      <h4 className="font-bold text-gray-900 mb-4">Verification Status</h4>
                      <div className="space-y-3">
                        <div>
                          <p className="text-sm text-gray-600 mb-1">Current Status</p>
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-yellow-100 text-yellow-700">
                            Pending Review
                          </span>
                        </div>
                        <div>
                          <p className="text-sm text-gray-600 mb-1">Quality Check</p>
                          <div className="flex items-center gap-2">
                            <div className="flex-1 bg-gray-200 rounded-full h-2">
                              <div className="bg-green-600 h-2 rounded-full" style={{ width: '85%' }}></div>
                            </div>
                            <span className="text-sm font-semibold text-gray-900">85%</span>
                          </div>
                        </div>
                        <div>
                          <p className="text-sm text-gray-600 mb-1">Readability</p>
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-700">
                            <i className="ri-check-line mr-1"></i>
                            Clear & Readable
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Verification Actions */}
                  <div className="bg-emerald-50 rounded-xl p-6 border-2 border-emerald-200">
                    <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <i className="ri-shield-check-line text-emerald-600"></i>
                      Document Verification
                    </h4>
                    <p className="text-gray-700 mb-4">Review this document carefully and verify that all information is clear, valid, and matches the user's profile.</p>
                    <div className="flex gap-3">
                      <button 
                        onClick={() => {
                          handleCloseDocumentViewer();
                          handleApproveKyc(selectedKycRequest);
                        }}
                        className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                      >
                        <i className="ri-check-line text-xl"></i>
                        Approve Document
                      </button>
                      <button 
                        onClick={() => {
                          handleCloseDocumentViewer();
                          handleRejectKyc(selectedKycRequest);
                        }}
                        className="flex-1 px-6 py-3 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                      >
                        <i className="ri-close-line text-xl"></i>
                        Reject Document
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
